import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';
import { usePreviewMode } from '@wp-block-builder/editor/hooks';
import { TBlock } from '@wp-block-builder/package';

import { TColumnsSectionBlock } from '../';

import DesktopBlockLayout from './DesktopBlockLayout';
import MobileBlockLayout from './MobileBlockLayout';

type TChildBlockRenderer = (block: TBlock | null, index: number) => JSX.Element;

type Props = {
  block: TColumnsSectionBlock;
  renderChildBlock: TChildBlockRenderer;
};
export function ReadOnlyBlockLayout({ block, renderChildBlock }: Props) {
  if (block.props?.mobileLayout === 'stacked') {
    return (
      <>
        <DesktopBlockLayout block={block} renderChildBlock={renderChildBlock} />
        <MobileBlockLayout block={block} renderChildBlock={renderChildBlock} />
      </>
    );
  }
  return <DesktopBlockLayout block={block} renderChildBlock={renderChildBlock} />;
}

function useIsMobile() {
  const [mode] = usePreviewMode();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.only('xs'));
  return mode === 'MOBILE' || isMobileView;
}

export function EditableBlockLayout({ block, renderChildBlock }: Props) {
  const isMobileView = useIsMobile();

  if (isMobileView && block.props?.mobileLayout === 'stacked') {
    return <MobileBlockLayout block={block} renderChildBlock={renderChildBlock} />;
  }
  return <DesktopBlockLayout block={block} renderChildBlock={renderChildBlock} />;
}
